import React, { useEffect } from 'react';
import 'theoplayer/ui.css';
import './Player.css';

import {
  setClientToSdk,
  groupSeek,
  stopSync,
  attachDeltaListener,
  attachPlaybackRateListener,
  setGroup,
  startSynchronize,
} from 'services/SyncService';
import { useSelector } from 'react-redux';
import HLSPlayer from './Players/HLS';
import YoutubePlayer from './Players/Youtube';

const Player = ({ isLoggedIn, isSyncRequired, componentStream }) => {
  const { syncToken, userName, isHost, isCelebrity } = useSelector((state) => state.celebrity);
  const { participants } = useSelector((state) => state.session);

  useEffect(() => {
    if (!syncToken || !isSyncRequired || isCelebrity) {
      return;
    }

    async function sync() {
      try {
        await setGroup(syncToken, 'Sceenic', !isHost);
        await startSynchronize();
      } catch (e) {
        if (e?.message === 'Player is not attached') {
          setTimeout(() => {
            sync();
          }, 1000);
        } else {
          console.error('Synchronization error:', e);
        }
      }
    }

    sync();

    return () => {
      stopSync();
    };
  }, [syncToken, isSyncRequired]);

  useEffect(() => {
    attachDeltaListener((delta) => {
      const el = document.getElementById('delta-info');
      if (el) {
        el.innerText = `${delta}ms`;
      }
    });

    attachPlaybackRateListener((rate) => {
      const el = document.getElementById('rate-info');
      if (el) {
        el.innerText = Number(rate).toFixed(2);
      }
    });
  }, []);

  let PLAYER = HLSPlayer;
  if (userName === 'mob') {
    PLAYER = YoutubePlayer;
  }

  const showStats = participants.length > 0;

  return (
    <div className="player-container">
      {showStats && (
        <div className="sync-info">
          <div>
            Delta: <span id="delta-info"></span>
          </div>
          <div>
            Rate: <span id="rate-info"></span>
          </div>
        </div>
      )}

      <PLAYER isLoggedIn={isLoggedIn} isSyncRequired={isSyncRequired} componentStream={componentStream} />
    </div>
  );
};
export default Player;
